export const checkHasScale = (scale: number | undefined): boolean =>
  scale !== undefined && scale !== 0;
